/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  fetchCashflowCashbooks () {
    return new Promise((resolve, reject) => {
      axios.get('/cashflow/cashbooks')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCashflowBankAccounts () {
    return new Promise((resolve, reject) => {
      axios.get('/bank-account')
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  fetchVouchers (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/voucher/${payload.company_id}/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVoucher (context, accountId) {
    return new Promise((resolve, reject) => {
      axios.get(`/voucher/${accountId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createVoucher (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/voucher', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateVoucher (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/voucher/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteVoucher (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/voucher/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  exportPDF (context, payload) {
    return new Promise((resolve, reject) => {
      // Prepare query parameters
      const params = {
        company_id: payload.company_id,
        startDate: payload.startDate,
        endDate: payload.endDate,
        ...(payload.searchQuery && { searchQuery: payload.searchQuery })
      }

      // Make GET request with responseType blob for PDF
      axios.get('voucher/export-pdf', {
        params,
        responseType: 'blob'
      })
        .then(response => {
        // Create blob from response
          const blob = new Blob([response.data], { type: 'application/pdf' })

          // Create download link
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.target = '_blank'

          // Optional: Set filename
          const fileName = `journal-vouchers-${new Date().getTime()}.pdf`
          link.download = fileName

          // Trigger download
          document.body.appendChild(link)
          link.click()

          // Clean up
          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
            resolve()
          }, 100)
        })
        .catch(async (error) => {
        // Cek apakah respons dalam bentuk blob tapi sebenarnya berisi JSON error
          if (
            error.response &&
          error.response.data instanceof Blob &&
          error.response.data.type === 'application/json'
          ) {
          // Baca blob sebagai text, lalu parse JSON-nya
            const text = await error.response.data.text()
            const json = JSON.parse(text)
            reject(json) // Bisa tampilkan error.message ke user
          } else {
          // Error umum
            reject(error)
          }
        })
    })
  },
  exportExcel (context, payload) {
    return new Promise((resolve, reject) => {
      const params = {
        company_id: payload.company_id,
        startDate: payload.startDate,
        endDate: payload.endDate,
        ...(payload.searchQuery && { searchQuery: payload.searchQuery })
      }

      axios.get('voucher/export-excel', {
        params,
        responseType: 'blob'
      })
        .then(response => {
        // Buat blob dari response dengan MIME type Excel
          const blob = new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          )

          // Buat elemen <a> untuk trigger download
          const link = document.createElement('a')
          const url = window.URL.createObjectURL(blob)
          link.href = url

          // Nama file bawaan
          const fileName = `journal-vouchers-${new Date().toISOString().slice(0, 10)}.xlsx`
          link.download = fileName

          // Trigger download
          document.body.appendChild(link)
          link.click()

          // Bersihkan
          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            resolve()
          }, 100)
        })
        .catch(async (error) => {
        // Jika error dalam format blob tapi berisi JSON
          if (
            error.response &&
          error.response.data instanceof Blob &&
          error.response.data.type === 'application/json'
          ) {
            const text = await error.response.data.text()
            const json = JSON.parse(text)
            reject(json)
          } else {
            reject(error)
          }
        })
    })
  }

}
